import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const MessageWrapper = styled.div`
	position: relative;
	${hoverable};
	height: 30px;
	width: 160px;
	&:after {
		content: 'Click to unlock';
		position: absolute;
		font-weight: 500;
		font-size: 12px;
		top: 7px;
		left: 100%;
		margin-left: 4px;
		display: inline-block;
		color: var(--color-white-05);
		white-space: nowrap;
	}
	span:not(.unlock) {
		opacity: 0;
		visibility: hidden;
	}
`;
